export const ValidateInput = (value, fieldName) => {
    
    if (!value.trim()) {
        return `${fieldName} is required.`;
    }
    // if (fieldName === "User Code" && value.length < 3) {
    //     return "User Code must be at least 3 characters long.";
    // }
    // if (fieldName === "Password" && value.length < 6) {
    //     return "Password must be at least 6 characters long.";
    // }
    return "";
};